angular.module('impactx.approval').directive('ixApprovalStatusChip', function() {
    return {
        scope: {
            status: '=',
            message: '='
        },
        restrict: 'E',
        templateUrl: 'shared/approval/templates/approval-status-chip.tmpl.html',
        link: function(scope) {
            switch(scope.status) {
                case 0: scope.statusColor = 'bg-grey'; break;
                case 2: scope.statusColor = 'bg-green'; break;
                case 3: scope.statusColor = 'bg-yellow'; break;
                case 4: scope.statusColor = 'bg-blue'; break;
                case 5: scope.statusColor = 'bg-yellow'; break;
                case 6: scope.statusColor = 'bg-red'; break;
                case 7: scope.statusColor = 'bg-orange'; break;
                default: scope.statusColor = 'bg-grey'
            }
        }
    }
});